<template lang="html">

    <div class="wrapper margin-menu -login column-center">

        <div class="contenedor-formulario-login">
            <h1 class="title-intro">Iniciar sesión</h1>
            <formulario></formulario>
            <span class="o">ó</span>
            <a @click="showRecuperarPass = true" class="recover-pass">Recuperar contraseña</a>
            <router-link :to="$t('enlaces.registro')" class="btn with-border">Crear usuario</router-link>
            <recuperar-pass @close="showRecuperarPass = false" v-if="showRecuperarPass"></recuperar-pass>
        </div>

    </div>


</template>

<script lang="js">

    import formulario from '@/components/view-parts/login/formulario'
    import recuperarpass from '@/components/view-parts/login/recuperar-pass'

    export default {
        name: 'login',
        data:() => ({
            showRecuperarPass : false
        }),
        components: {
            'formulario': formulario,
            'recuperar-pass': recuperarpass
        }
    }

</script>


<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/login.vue